var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.958 2.977C6.92-.973 13.371-.995 17.362 2.925a9.998 9.998 0 0 1 1.148 12.957L25 22.3 22.27 25l-6.544-6.471c-3.937 2.528-9.254 2.098-12.72-1.305a10 10 0 0 1-.048-14.247Zm12.607 1.737c-2.99-2.942-7.828-2.922-10.8.038A7.493 7.493 0 0 0 4.8 15.435c2.995 2.944 7.831 2.926 10.804-.034a7.498 7.498 0 0 0-.04-10.687Z",
    fillRule: "evenodd"
  })));
};
export default SvgSearch;